import { supabase } from "@/integrations/supabase/client";

/**
 * Returns the active workspace ID from localStorage.
 * This is a synchronous helper for use inside async query functions
 * that don't have access to React hooks.
 */
export function getActiveWorkspaceId(): string | null {
  return localStorage.getItem("subtrackr_active_workspace");
}

/**
 * Adds workspace_id filter to a Supabase query builder.
 * Usage: pass the result of .select() or .eq() etc through this function.
 * Uses `as any` cast internally to avoid deep type instantiation issues with Supabase types.
 */
export function withWorkspaceFilter<T>(query: T): T {
  const workspaceId = getActiveWorkspaceId();
  if (workspaceId) {
    return (query as any).eq("workspace_id", workspaceId) as T;
  }
  return query;
}

/**
 * Returns a workspace_id field for INSERT operations.
 * Should be spread into insert payloads for workspace-scoped tables.
 */
export function workspaceInsertFields(): { workspace_id?: string } {
  const workspaceId = getActiveWorkspaceId();
  return workspaceId ? { workspace_id: workspaceId } : {};
}
